import { ProductCapability, hasCapability } from "@constructorfleet/offerings-sdk";
import type { WebsiteProductOfferingPlugin } from "./types";

export function offeringHasCapability(
  offering: WebsiteProductOfferingPlugin,
  capability: ProductCapability
) {
  const capabilities = offering.manifest?.capabilities;
  if (capabilities != null) {
    return hasCapability(capabilities, capability);
  }

  if (capability === ProductCapability.Routes) {
    return Boolean(offering.httpRoutes && offering.httpRoutes.length > 0);
  }

  if (capability === ProductCapability.AdminSettings) {
    return typeof offering.adminUI === "function";
  }

  if (capability === ProductCapability.Billing) {
    return Boolean(offering.billing);
  }

  if (capability === ProductCapability.BackgroundJob) {
    return false;
  }

  return true;
}
